<div class="actions-column" tabindex="0" style="outline: none;" *ngIf="actions">
  <div dropdown style="position:relative;" (onShown)="getItems()">
    <a class="btn-group" dropdownToggle>
      <i class="fa fa-ellipsis-v" style="font-size:1.86em;color: #6d6b6b;" aria-hidden="true"></i>
    </a>
    <app-drop-item [actions]="actions" *dropdownMenu id="dropdownMenu" class="dropdown-menu" aria-labelledby="profile-sm"
      style="float:right; right:3px; left: auto;"></app-drop-item>
  </div>
</div>